import * as React from "react";
import { useEffect, useState } from "react";
const Delayed = ({ children, delay }) => {
  const [delayFinished, setDelayFinished] = useState(delay <= 0);
  useEffect(() => {
    if (delay <= 0) {
      return () => {
      };
    }
    const delayTimeout = window.setTimeout(() => setDelayFinished(true), delay);
    return () => clearTimeout(delayTimeout);
  }, []);
  return delayFinished ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : null;
};
export default Delayed;
